var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserProfileIcon = function SvgUserProfileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6F1F2",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.857 16.916C5.171 14.996 7.332 13.75 10 13.75s4.83 1.247 6.143 3.166m-12.286 0A9.22 9.22 0 0 0 10 19.25c2.358 0 4.51-.882 6.143-2.334m-12.286 0a9.25 9.25 0 1 1 12.286 0M13.25 8a3.25 3.25 0 1 1-6.5 0 3.25 3.25 0 0 1 6.5 0Z"
  })));
};
export { SvgUserProfileIcon as ReactComponent };
export default __webpack_public_path__ + "27f08435738a3a6727a2f201536f3258.svg";